"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFocusedParticipantId = void 0;
const getNextSpeakerId_1 = require("./getNextSpeakerId");
const hasStickBeenPassed_1 = require("./hasStickBeenPassed");
/**
 * Gets the id of the participant that is either speaking or deciding whether or not to take the stick.
 * This is the participant that's name is usually displayed in the center of the discussion and is pointed at
 * by the highlight arrow.
 */
function getFocusedParticipantId(discussion) {
    if (hasStickBeenPassed_1.hasStickBeenPassed(discussion)) {
        return getNextSpeakerId_1.getNextSpeakerId(discussion);
    }
    return discussion.stickHolderId;
}
exports.getFocusedParticipantId = getFocusedParticipantId;
//# sourceMappingURL=getFocusedParticipantId.js.map